<template>
  <div>
    <div class="db-filter-modal">
      <div class="db-filter-title-text">Edit {{ editData.nama }}</div>
      <div class="db-filter-edit-form">

        <div v-for="(key) in Object.keys(editData.legal_dokumen)" :key="key" class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">{{ editData['legal_dokumen'][key]['name'] }}</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select" v-model="editData['legal_dokumen'][key]['value']">
              <option value="0">Tidak Mandatory</option>
              <option value="1">Mandatory</option>
              <option value="11" v-if="editData['legal_dokumen'][key]['type'] == 1">Group 1 (salah satu mandatory)
              </option>
              <option value="12" v-if="editData['legal_dokumen'][key]['type'] == 2">Group 2 (salah satu mandatory)
              </option>
              <option value="13" v-if="editData['legal_dokumen'][key]['type'] == 3">Group 3 (salah satu mandatory)
              </option>
            </select>
          </div>
        </div>

      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal">CANCEL</div>
          <div class="email-button" @click="saveMatrix">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../../../services/config'
export default {
  props: {
    'editData': Object,
  },


  data() {
    return {
      legal_dokumen: [
        {
          name: 'Logo Perusahaan',
          id: 44,
          value: 0
        },
        {
          name: 'Formulir Vendor',
          id: 33,
          value: 0
        },
        {
          name: 'Surat Pakta Integritas',
          id: 31,
          value: 0
        },
        {
          name: 'Non PKP',
          id: 7,
          value: 0
        },
        {
          name: 'Akta Pendirian Perseroan',
          id: 1,
          value: 0
        },
        {
          name: 'Akta Penyesuaian PT',
          id: 2,
          value: 0
        },
        {
          name: 'Akta Anggaran Dasar Terakhir',
          id: 3,
          value: 0
        },
        {
          name: 'Akta Perubahan Pengurus Terbaru',
          id: 4,
          value: 0
        },
        {
          name: 'NPWP',
          id: 5,
          value: 0
        },
        {
          name: 'SPPKP Pajak',
          id: 6,
          value: 0
        },
        {
          name: 'SKT Pajak',
          id: 8,
          value: 0
        },
        {
          name: 'Cover Depan Buku Tabungan',
          id: 34,
          value: 0
        },
        {
          name: 'Financial Report',
          id: 10,
          value: 0
        },
        {
          name: 'Company Profile',
          id: 9,
          value: 0
        },
        {
          name: 'SK Domisili',
          id: 11,
          value: 0
        },
        {
          name: 'NIB',
          id: 12,
          value: 0
        },
        {
          name: 'TDP',
          id: 13,
          value: 0
        },
        {
          name: 'SIUP',
          id: 14,
          value: 0
        },
        {
          name: 'SS',
          id: 15,
          value: 0
        },
        {
          name: 'IUJP',
          id: 16,
          value: 0
        },
        {
          name: 'SBUJK',
          id: 17,
          value: 0
        },
        {
          name: 'IUJPTL',
          id: 18,
          value: 0
        },
        {
          name: 'INU BBM',
          id: 19,
          value: 0
        },
        {
          name: 'SIUPAL',
          id: 20,
          value: 0
        },
        {
          name: 'IUPPJPB',
          id: 21,
          value: 0
        },
        {
          name: 'SIUPBM',
          id: 22,
          value: 0
        },
        {
          name: 'SIUJS',
          id: 23,
          value: 0
        },
        {
          name: 'Izin Usaha Angkutan Sungai Danau',
          id: 37,
          value: 0
        },
        {
          name: 'SIUJPT',
          id: 24,
          value: 0
        },
        {
          name: 'SIPL',
          id: 26,
          value: 0
        },
        {
          name: 'IUI',
          id: 25,
          value: 0
        }
      ],
    }
  },

  methods: {
    async saveMatrix() {
      try {
        await this.$store.commit('SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/md-matrix-legal`,
          data: {
            m_badan_usaha_id: this.editData.id,
            matrix: this.editData.legal_dokumen
          }
        })

        if (data && data.status === 'success') {
          this.$emit('closeModal')
          await this.$store.commit(
            'SET_NOTIF',
            'Berhasil mengubah data',
          )
          await this.$store.dispatch('mdMatrixLegalStore/getMatrix')
          await this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        await this.$store.commit(
          'SET_NOTIF',
          error.response.data.message,
        )
        await this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>